import { render, staticRenderFns } from "./JcButton.vue?vue&type=template&id=1c4d21ba&"
import script from "./JcButton.vue?vue&type=script&lang=js&"
export * from "./JcButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports